import { useNavigate } from "react-router-dom";

interface HeaderProps {
  totalTasks: number;
  pendingTasks: number;
}

const Header = ({ totalTasks, pendingTasks }: HeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-4xl font-bold text-gray-900">Minhas Tarefas</h1>
        <button
          onClick={() => navigate("/tasks/create")}
          className="bg-blue-600 text-white px-6 py-3 rounded-xl font-medium hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
        >
          + Nova Tarefa
        </button>
      </div>
      <p className="text-gray-600 text-lg">
        {totalTasks} {totalTasks === 1 ? "tarefa" : "tarefas"} • {pendingTasks}{" "}
        pendente{pendingTasks !== 1 ? "s" : ""}
      </p>
    </div>
  );
};

export { Header };
